import React, {PropsWithChildren} from 'react'
import {SlctInternalProps} from 'module/Slct/type/SlctType'
import {ListChildComponentProps} from 'react-window'
import {SlctOptionComponent} from 'module/Slct/component/SlctOptionComponent'

/**
 * Wrapper for react-window FixedSizeList
 */
export function SlctOptionWrapperComponent<ModelType extends object | void, ValueType extends string | number>(props: PropsWithChildren<ListChildComponentProps<SlctInternalProps<ModelType, ValueType>>>) {
	const {data, index, style} = props
	return <div style={{...style, width: undefined, minWidth: '100%'}}>
		<SlctOptionComponent {...data} index={index}/>
	</div>
}